<!-- 

<div class="ttmodal" style="min-width: 50vw;">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Product Improvement</span>
     
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>

  <div class="ttmodal__body">    
    <div class="ttmodal__header">
      </div>
 
      <div  style="overflow-y: auto; height:350px; ">
      <table class="table table--striped table--full-width">
          <thead>             
              <th style="padding: 1px!important;">PIP</th>
              <th style="padding: 1px!important;">Status</th>
              <th  style="padding: 1px!important;"> Start Date</th>
              <th style="padding: 1px!important;">Completed Date</th>
              <th style="padding: 1px!important;">PIP Notes</th>             
            
          </thead>
          <tbody>
            <tr *ngFor="let pip of PIPImplmentsLevelList">
              <td style="padding: 1px!important; cursor: pointer;" (click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.PIPId}}</td>
              <td style="padding: 1px!important;cursor: pointer;"  (click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.Status ==1? 'Open': Close}}</td> 
              <td style="padding: 1px!important;cursor: pointer;" (click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.StartDate}}</td>
              <td style="padding: 1px!important;cursor: pointer;"(click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.completedDate}}</td>
              <td style="padding: 1px!important;cursor: pointer;" (click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.PIPNotes}}</td>
 
            </tr>
          </tbody>
      </table>
      </div>
  </div>

</div> -->




<div class="ttmodal" style="min-width: 50vw;">
  <div class="ttmodal__header">
      <span class="ttmodal__title">{{'Product Improvement' | translate | async}}</span>

      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>

  <div class="ttmodal__body">    
    <div class="ttmodal__header">
      </div>
 
      <div  style="overflow-y: auto; height:350px; ">
        <div style="margin-left: 20%; position: absolute;" *ngIf="isLoading">
          <mat-spinner></mat-spinner>
        </div>
      <table class="table table--striped table--full-width">
          <thead>             
              <th style="text-align: center;">{{'PIP No' | translate | async}}</th>
              <th style="text-align: center;">{{'Status' | translate | async}}</th>
              <th style="text-align: center;">{{'Start Date' | translate | async}}</th>

              <th style="text-align: center;">{{'Completed Date' | translate | async}}</th>
              <th style="text-align: center;">{{'PIP Notes' | translate | async}}</th>            
            
          </thead>
          <tbody>
            <tr *ngFor="let pip of PIPImplmentsLevelList">
            
              <td style="text-align: center; cursor: pointer;" (click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.PIPNumber}}</td>
              <td style="text-align: center; cursor: pointer;" (click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.Status ==1? 'Open': 'Close'}}</td>
              <td  style="text-align: center; cursor: pointer;"(click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.StartDate}} </td>
              <td style="text-align: center; cursor: pointer;"(click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.completedDate}}</td>    
              <td style="text-align: center; cursor: pointer;" (click)="openProdImprovementAssetScreen(pip.Id,pip.PIPId)">{{pip.PIPNotes}}</td>           

            </tr>
          </tbody>
      </table>
      </div>
  </div>

</div>